import CardComponent from './CardComponent';

export class ButtonCallback extends CardComponent {}
